import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { AdminService } from 'src/app/services/admin/admin.service';
import { ThemeService } from 'src/app/services/theme/theme.service';

@Component({
  selector: 'app-change-themes',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './change-themes.component.html',
  styleUrl: './change-themes.component.css'
})
export class ChangeThemesComponent {

  @Input() isName = true

  constructor(public adminService: AdminService, public themeService: ThemeService) {}

  setTheme(theme: 'system' | 'dark' | 'light') {
    this.themeService.setTheme(theme);
  }

}
